export const LOGIN = "LOGIN";
export const CLOSESESSION = "CLOSESESSION";
export const KEYWORD = "KEYWORD";
export const TEST_LOCAL = "TEST_LOCAL";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
